var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container calendar-list-container" },
    [
      _c(
        "div",
        { staticClass: "filter-container" },
        [
          _c("el-input", {
            staticStyle: { width: "200px" },
            attrs: {
              type: "text",
              clearable: "",
              placeholder: "请输入报修单号/详情"
            },
            model: {
              value: _vm.listQuery.value,
              callback: function($$v) {
                _vm.$set(_vm.listQuery, "value", $$v)
              },
              expression: "listQuery.value"
            }
          }),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "请选择工单状态", clearable: "" },
              model: {
                value: _vm.listQuery.status,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "status", $$v)
                },
                expression: "listQuery.status"
              }
            },
            _vm._l(_vm.repairStatu, function(item) {
              return _c("el-option", {
                key: item.dicValue,
                attrs: { label: item.dicName, value: item.dicValue }
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "请选择工单优先级", clearable: "" },
              model: {
                value: _vm.listQuery.situationType,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "situationType", $$v)
                },
                expression: "listQuery.situationType"
              }
            },
            _vm._l(_vm.degreeOption, function(item) {
              return _c("el-option", {
                key: item.dicValue,
                attrs: { label: item.dicName, value: item.dicValue }
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "200px" },
              attrs: { placeholder: "请选择来源", clearable: "" },
              model: {
                value: _vm.listQuery.repairSource,
                callback: function($$v) {
                  _vm.$set(_vm.listQuery, "repairSource", $$v)
                },
                expression: "listQuery.repairSource"
              }
            },
            _vm._l(_vm.sourceOption, function(item) {
              return _c("el-option", {
                key: item.dicValue,
                attrs: { label: item.dicName, value: item.dicValue }
              })
            }),
            1
          ),
          _c(
            "el-button",
            {
              directives: [{ name: "waves", rawName: "v-waves" }],
              attrs: { type: "primary", icon: "el-icon-search" },
              on: { click: _vm.handleFilter }
            },
            [_vm._v(_vm._s(_vm.$t("button.search")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", icon: "el-icon-circle-plus-outline" },
              on: { click: _vm.handleCreate }
            },
            [_vm._v(_vm._s(_vm.$t("button.add")))]
          )
        ],
        1
      ),
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.listLoading,
              expression: "listLoading"
            }
          ],
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.list,
            "element-loading-text": "数据正在加载中...",
            border: "",
            stripe: "",
            fit: "",
            "highlight-current-row": ""
          },
          on: { "selection-change": _vm.handleSelectionChange }
        },
        [
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.repairNum"),
              "min-width": "150px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "link-type",
                        on: {
                          click: function($event) {
                            return _vm.getDetail(
                              scope.row.repairId,
                              scope.row.flowNum
                            )
                          }
                        }
                      },
                      [_vm._v(_vm._s(scope.row.flowNum))]
                    )
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.userState"),
              "min-width": "130px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.flowStatus == "0"
                      ? _c("el-tag", { attrs: { type: "warning" } }, [
                          _vm._v("未处理")
                        ])
                      : scope.row.flowStatus == "1"
                      ? _c("el-tag", [_vm._v("处理中")])
                      : scope.row.flowStatus == "2"
                      ? _c("el-tag", { attrs: { type: "info" } }, [
                          _vm._v("维修完成待确认")
                        ])
                      : scope.row.flowStatus == "3"
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("已确认通过")
                        ])
                      : scope.row.flowStatus == "4"
                      ? _c("el-tag", { attrs: { type: "danger" } }, [
                          _vm._v("已确认不通过")
                        ])
                      : scope.row.flowStatus == "5"
                      ? _c("el-tag", { attrs: { type: "success" } }, [
                          _vm._v("已归档")
                        ])
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.pecinct"),
              "min-width": "130px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.areaName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: _vm.$t("table.repairType") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.repairTypeName))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.addTime"),
              "min-width": "155px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.repairTime))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.repairPerson"),
              "min-width": "120px",
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.repairUserName))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.contactMan"),
              "min-width": "100px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.contact))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.precinctPhone"),
              "min-width": "110px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.phone))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.repairDetail"),
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.content))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.positionInfo"),
              "show-overflow-tooltip": "",
              "min-width": "130px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          scope.row.houseCode + "-" + scope.row.deviceAddress
                        )
                      )
                    ])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: _vm.$t("table.urgencyDegree") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.situationTypeName))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: _vm.$t("table.workOrderType") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.orderTypeName))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: _vm.$t("table.classWorkList") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.orderSubTypeName))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: _vm.$t("table.source") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.repairSourceName))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: { align: "center", label: _vm.$t("table.evaluate") },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    _c("span", [_vm._v(_vm._s(scope.row.visitRatingValue))])
                  ]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.valuateContent"),
              "show-overflow-tooltip": ""
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [_c("span", [_vm._v(_vm._s(scope.row.visitRemark))])]
                }
              }
            ])
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              label: _vm.$t("table.actions"),
              "min-width": "280px"
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function(scope) {
                  return [
                    scope.row.flowStatus == "0"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              plain: "",
                              icon: "el-icon-edit"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleUpdate(
                                  scope.row.repairId,
                                  scope.row.flowNum
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.edit")))]
                        )
                      : _vm._e(),
                    scope.row.flowStatus == "0"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "danger",
                              size: "mini",
                              plain: "",
                              icon: "el-icon-delete"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleDelete(scope.row.repairId)
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.delete")))]
                        )
                      : _vm._e(),
                    scope.row.flowStatus == "0"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              icon: "el-icon-news",
                              plain: ""
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleDispatch(
                                  scope.row.repairId,
                                  scope.row.flowNum
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.sendExtand")))]
                        )
                      : _vm._e(),
                    scope.row.flowStatus == "2"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              plain: "",
                              icon: "el-icon-check"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleConfirm(
                                  scope.row.repairId,
                                  scope.row.flowNum
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.affirm")))]
                        )
                      : _vm._e(),
                    !scope.row.visitRatingValue
                      ? _c(
                          "div",
                          { staticStyle: { display: "inline-block" } },
                          [
                            scope.row.flowStatus == "3" ||
                            scope.row.flowStatus == "4" ||
                            scope.row.visitRatingValue
                              ? _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      plain: "",
                                      icon: "el-icon-edit-outline"
                                    },
                                    on: {
                                      click: function($event) {
                                        return _vm.handleEvaluate(
                                          scope.row.repairId
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v(_vm._s(_vm.$t("button.evaluate")))]
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e(),
                    scope.row.flowStatus == "3" || scope.row.flowStatus == "4"
                      ? _c(
                          "el-button",
                          {
                            attrs: {
                              type: "primary",
                              size: "mini",
                              plain: "",
                              icon: "el-icon-edit-outline"
                            },
                            on: {
                              click: function($event) {
                                return _vm.handleArchive(
                                  scope.row.repairId,
                                  scope.row.flowNum
                                )
                              }
                            }
                          },
                          [_vm._v(_vm._s(_vm.$t("button.archive")))]
                        )
                      : _vm._e()
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "pagination-container" },
        [
          _c("el-pagination", {
            attrs: {
              background: "",
              "current-page": _vm.listQuery.page,
              "page-sizes": [10, 20, 30, 50],
              "page-size": _vm.listQuery.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogFormVisible,
            width: "920px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogFormVisible = $event
            }
          }
        },
        [
          _c("repair-add", {
            attrs: {
              "key-value": _vm.customerId,
              "show-dialog": _vm.dialogFormVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogDetailVisible,
            width: "920px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogDetailVisible = $event
            }
          }
        },
        [
          _c("repair-detail", {
            attrs: {
              "key-value": _vm.id,
              "flow-num": _vm.flowNum,
              "show-dialog": _vm.dialogDetailVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogDispatchVisible,
            width: "920px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogDispatchVisible = $event
            }
          }
        },
        [
          _c("repair-dispatch", {
            attrs: {
              "key-value": _vm.id,
              "flow-num": _vm.flowNum,
              "show-dialog": _vm.dialogDispatchVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogEvaluateVisible,
            width: "500px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogEvaluateVisible = $event
            }
          }
        },
        [
          _c("repair-evaluate", {
            attrs: {
              "key-value": _vm.id,
              "show-dialog": _vm.dialogEvaluateVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogArchiveVisible,
            width: "920px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogArchiveVisible = $event
            }
          }
        },
        [
          _c("repair-archive", {
            attrs: {
              "key-value": _vm.id,
              "flow-num": _vm.flowNum,
              "show-dialog": _vm.dialogArchiveVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.dialogConfirmVisible,
            width: "920px"
          },
          on: {
            "update:visible": function($event) {
              _vm.dialogConfirmVisible = $event
            }
          }
        },
        [
          _c("repair-confirm", {
            attrs: {
              "key-value": _vm.customerId,
              "flow-num": _vm.flowNum,
              "show-dialog": _vm.dialogConfirmVisible
            },
            on: { handCancle: _vm.handCancle }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }